module.exports = __webpack_public_path__ + "statics/img/2-4.f18cdab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/2-4.png
// module id = IdHA
// module chunks = 1